<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1 style="padding-bottom:10px;">Acknowledgments</h1>
<p>I would like to acknowledge that without my husband Nicholas’ insistence, this collection of short stories would still be sitting on a shelf, collecting dust. Thank you for the push.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?310d6042